import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { ttPage, ttViewContent } from "@/lib/tiktok";
import { fbViewContent, fbRestoreMatch } from "@/lib/meta";

const GA_ID = "G-7Q5HBJ9BW9";

export function TikTokRouteTracker() {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__gaConfigured || typeof window.gtag !== "function") return;
        window.__gaConfigured = true;
        window.gtag("config", GA_ID);
    }, []);
    useEffect(fbRestoreMatch, []);
    const last = useRef(pathname);
    useEffect(() => {
        if (last.current === pathname) return;
        last.current = pathname;
        ttPage();
    }, [pathname]);
    return null;
}

export function useTikTokViewContent(product) {
    const sent = useRef(null);
    useEffect(() => {
        if (!product?.slug || sent.current === product.slug) return;
        sent.current = product.slug;
        ttViewContent(product);
        fbViewContent(product);
    }, [product]);
}
